import { Deduction, DeductionProps } from "@/core/entities/deduction/deduction/Deduction";
import { AccountingDeductionSubType, AccountingDeductionSubTypeProps } from "./AccountingDeductionSubType";
import { AccountingQBOItem, AccountingQBOItemProps } from "./AccountingQBOItem";

export interface AccountingDeductionGroupProps {
  deductionSubTypes: AccountingDeductionSubTypeProps[];
  qboItem: AccountingQBOItemProps;
  description: string;
  systemGenerated?: boolean;
  itemsCount: number;
  amount: number;
  deductions: DeductionProps[];
}

export class AccountingDeductionGroup {
  private readonly _deductionSubTypes: AccountingDeductionSubType[];
  private readonly _qboItem: AccountingQBOItem;
  private readonly _description: string;
  private readonly _systemGenerated: boolean;
  private readonly _itemsCount: number;
  private readonly _amount: number;
  private readonly _deductions: Deduction[];

  constructor(props: AccountingDeductionGroupProps) {
    this._deductionSubTypes = (props.deductionSubTypes ?? []).map(subType =>
      AccountingDeductionSubType.fromJson(subType)
    );
    this._qboItem = AccountingQBOItem.fromJson(props.qboItem);
    this._description = props.description;
    this._systemGenerated = props.systemGenerated ?? false;
    this._itemsCount = props.itemsCount;
    this._amount = Number(props.amount);
    this._deductions = (props.deductions ?? []).map(deduction => new Deduction(deduction));
  }

  public get deductionSubTypes(): AccountingDeductionSubType[] {
    return this._deductionSubTypes;
  }

  public get qboItem(): AccountingQBOItem {
    return this._qboItem;
  }

  public get description(): string {
    return this._description;
  }

  public get systemGenerated(): boolean {
    return this._systemGenerated;
  }

  public get itemsCount(): number {
    return this._itemsCount;
  }

  public get amount(): number {
    return this._amount;
  }

  public get deductions(): Deduction[] {
    return this._deductions;
  }

  public static fromJson(props: AccountingDeductionGroupProps): AccountingDeductionGroup {
    return new AccountingDeductionGroup(props);
  }
}
